import { render, staticRenderFns } from "./select-admin.vue?vue&type=template&id=55e3d3a8"
import script from "./select-admin.vue?vue&type=script&lang=js"
export * from "./select-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports